import { defaultFacilityValues } from "@/consts/defaultFacilityValues";
import moment, { Moment } from "moment";

export const getFormattedDateTimeString = (date: Date, facilityDateFormat: string, facilityTimeFormat: string | null, addYears: boolean) => {

    const timeFormat = facilityTimeFormat ? `, ${facilityTimeFormat}` : ''
    const dateFormat = facilityDateFormat || defaultFacilityValues.dateFormat

    if (addYears === true) {
        //format date time
        return moment(date).format(dateFormat + timeFormat)
    }
    else {
        //format date time and remove years
        const dateWithoutYearsFormat = dateFormat.replace(', YYYY', '').replace('YYYY, ', '')
        return moment(date).format(dateWithoutYearsFormat + timeFormat)
    }
}

/**
 * 
 * @param date - momentjs object or date
 * @param time - time in format '01:00 PM' or '13:00'
 */
export const setTimeForDate = (date: Moment | Date, time: string) => {

    //get time format 'AM' or 'PM' or ''. Empty string == 24 h format
    const timeFormat = time.split(' ')[1]

    let updatedTime = ''
    if (timeFormat == 'AM' || timeFormat == 'PM') {
        //convert time to 24h format
        updatedTime = moment(time, ["h:mm A"]).format("HH:mm");
    }
    else {
        //remove 'AM' and 'PM' from time string
        updatedTime = time.split(' ')[0]
    }

    //convert hours and minutes from string to number ('07' -> 7)
    const hours = parseInt(updatedTime.split(":")[0])
    const minutes = parseInt(updatedTime.split(":")[1])

    if (moment.isMoment(date)) {
        //set time for moment date object
        date.set({ hour: hours, minute: minutes })
    }
    else {
        //set time for Date object
        date.setHours(hours, minutes);
    }

    console.log('time: ' + updatedTime)
}

export const convertTimeDurationTo24hFormat = (timeDuration: string) => {

    //split start time and end time
    const duration = timeDuration.split('-')

    let startTime = ''
    let endTime = ''

    //get time format 'AM' or 'PM' or ''. Empty string == 24 h format
    const timeFormat = duration[0].split(' ')[1]

    if (timeFormat == 'AM' || timeFormat == 'PM') {
        //convert time to 24h format
        startTime = moment(duration[0], ["h:mm A"]).format("HH:mm")
        endTime = moment(duration[1], ["h:mm A"]).format("HH:mm");
    }
    else {
        //remove 'AM' and 'PM' from time string
        startTime = duration[0].split(' ')[0]
        endTime = duration[1].split(' ')[0]
    }

    //return new time duration in 24h format
    const durationIn24h = `${startTime}-${endTime}`

    return durationIn24h
}

export const detectDateFormat = (dateString: string) => {
    const possibleFormats = [
        'DD-MM-YYYY',
        'MM-DD-YYYY',
        'YYYY-MM-DD',
    ];

    for (const format of possibleFormats) {
        if (moment(dateString, format, true).isValid()) {

            const dateParts = dateString.split('-')
            if(parseInt(dateParts[0]) <=12 && parseInt(dateParts[1]) <=12){
                return 'DD-MM-YYYY|MM-DD-YYYY'
            }
            return format;
        }
    }

    return null;
}

export const convertFacilityDateFormatToCsvFormat = (inputFormat) => {

    const dates = {
        'DD MMM, YYYY': 'DD-MM-YYYY',
        'MMM DD, YYYY': 'MM-DD-YYYY',
        'YYYY, MMM DD': 'YYYY-MM-DD'
    }

    const csvFormat = dates[inputFormat]

    return csvFormat
}

export const convertTimeTo24HourInArray = (time: string): string[] => {
    const [timePart, modifier] = time.split(' ');
    const minutes = timePart.split(':')[1]
    let hours = timePart.split(':')[0];

    if (hours === '12') {
        hours = '00';
    }

    if (modifier && modifier === 'PM') {
        hours = String(parseInt(hours, 10) + 12);
    }

    return [hours, minutes];
}

export const convertToFullWeekdayNames = (shortWeekdays: string[]) => {
    const fullWeekdays = {
        "Sun": "Sunday",
        "Mon": "Monday",
        "Tue": "Tuesday",
        "Wed": "Wednesday",
        "Thu": "Thursday",
        "Fri": "Friday",
        "Sat": "Saturday"
    };

    return shortWeekdays.map(day => fullWeekdays[day]);
  }